module.exports = __webpack_public_path__ + "img/kr.7d07073.webp";